import Form, {
    SimpleItem, GroupItem, TabbedItem, ButtonItem,
    Label, Tab, RangeRule, RequiredRule
} from 'devextreme-react/form';
import React, { useState, useEffect } from 'react';
import dictionary from '../../data/dictionary';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadMessages, formatMessage, locale } from 'devextreme/localization';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { useHistory, useParams } from 'react-router-dom';
import FileSelectPopup from '../../components/file/FileSelectPopup';
import 'devextreme-react/text-area';
import 'devextreme-react/tag-box';
import notify from 'devextreme/ui/notify';
import useJSON from '../../hook/useJSON';
import { WEBSITE_URL } from '../../utils/constants';

loadMessages(dictionary);

const tabsMock = [{
    id: 0,
    text: 'vi-VN',
    icon: 'globe',
    content: 'Vietnamese'
}];

const notesEditorOptions = { height: 100 };

const PartnerVM = (data, languages) => {
    const returnData = useJSON(data, languages);
    return returnData;
};

const PartnerMV = (data, languages) => {
    const nameObj = {}; const descriptionObj = {};
    languages.forEach(language => {
        nameObj[[language.languageId]] = data[`name-${language.languageId}`];
        descriptionObj[[language.languageId]] = data[`description-${language.languageId}`];
    });

    return JSON.stringify({
        name: JSON.stringify(nameObj),
        description: JSON.stringify(descriptionObj),
        thumbnail: data.thumbnail,
        bannerImagesMobile: data.bannerImagesMobile,
        alt: data.alt,
        url: data.url,
        order: data.order,
        concurrencyStamp: data.concurrencyStamp,
        isActive: data.isActive
    });
};

const PartnerDetailContainer = ({ accessToken, currentLanguage, currentWebsite, websiteLanguages }) => {
    locale(currentLanguage.substring(0, 2));
    const [tabs, setTabs] = useState(tabsMock);
    const [partner, setPartner] = useState({});
    const history = useHistory();
    const params = useParams();

    useEffect(() => {
        if (!params.partnerId) return;

        fetch(`${WEBSITE_URL}Partners/${currentWebsite}/${params.partnerId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Access-Control-Allow-Origin': '*'
            }
        }).then(result => result.json()
            .then(json => {
                if (result.ok) {
                    setPartner(PartnerVM(json.data, websiteLanguages));
                    return;
                }
                throw json.Message;
            })
            .catch(() => {
                if (result.status === 401) {
                    history.push('/login');
                }
            })
        );
    }, [accessToken, websiteLanguages, currentWebsite, params.partnerId, history]);

    const updatePartner = () => {
        const _method = partner.id ? 'PUT' : 'POST';
        const _url = `${WEBSITE_URL}Partners/${currentWebsite}${partner.id ? `/${partner.id}` : ''}`;

        return fetch(_url, {
            method: _method,
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Accept-Language': currentLanguage
            },
            body: PartnerMV(partner, websiteLanguages)
        }).then(result => result.json()
            .then(json => {
                if (result.ok) {
                    history.push('/partner');
                    notify({
                        message: json.message,
                        position: {
                            my: 'center top',
                            at: 'center top'
                        }
                    }, 'success', 3000);
                    return;
                }
                throw json.Message;
            })
            .catch(() => {
                if (result.status === 401) {
                    history.push('/login');
                }
            })
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updatePartner();
    };

    useEffect(() => {
        const _tabs = websiteLanguages.map((item, index) => ({
            id: index,
            languageId: item.languageId,
            text: item.name,
            icon: 'globe',
            content: 'User tab content'
        }));
        setTabs(_tabs);
    }, [websiteLanguages]);

    const backButtonOptions = {
        type: 'back',
        onClick: () => {
            history.push('/partner');
        }
    };

    const updateThumbnail = e => {
        setPartner(prevState => ({ ...prevState, thumbnail: e }));
    };

    const saveButtonOptions = {
        text: 'Update',
        type: 'success',
        useSubmitBehavior: true
    };

    return (
        <React.Fragment>
            <Toolbar>
                <Item location="before"
                    widget="dxButton"
                    options={backButtonOptions} />
                <Item location="center"
                    text={'Chi tiết Partner'} />
            </Toolbar>

            <form action="your-action" onSubmit={handleSubmit}>
                <Form
                    formData={partner}
                    readOnly={false}
                    showColonAfterLabel={true}
                    colCount={2}
                    showValidationSummary={true}
                    validationGroup="customerData"
                >
                    <GroupItem caption="Thông tin cơ bản">
                        <GroupItem caption="Đa ngôn ngữ">
                            <TabbedItem>
                                {tabs.map((item) => {
                                    return (
                                        <Tab key={item.id} title={item.text} icon={item.icon}>
                                            <SimpleItem dataField={`name-${item.languageId}`} editorType="dxTextBox">
                                                <Label text={formatMessage('name')} />
                                                <RequiredRule message={`${formatMessage('name')} ${formatMessage('errMesRequire')}`} />
                                            </SimpleItem>
                                            <SimpleItem dataField={`description-${item.languageId}`} editorType="dxTextArea" editorOptions={notesEditorOptions}>
                                                <Label text={formatMessage('description')} />
                                            </SimpleItem>
                                        </Tab>
                                    );
                                })}
                            </TabbedItem>
                        </GroupItem>

                    </GroupItem>
                    <GroupItem caption="Thông tin khác" colCount={2}>
                        <GroupItem>
                            <SimpleItem >
                                <Label text={formatMessage('thumbnail')} />
                                <FileSelectPopup value={partner.thumbnail} imgHeight={100}
                                    onValueChanged={updateThumbnail} />
                            </SimpleItem>
                        </GroupItem>

                        <GroupItem>
                            <SimpleItem dataField={'alt'} editorType="dxTextArea" colSpan={2}>
                                <Label text={formatMessage('alt')} />
                            </SimpleItem>
                            <SimpleItem dataField={'url'} editorType="dxTextBox" colSpan={2}>
                                <Label text={formatMessage('url')} />
                            </SimpleItem>
                            <SimpleItem dataField={'order'} editorType="dxNumberBox">
                                <Label text={'Thứ tự'} />
                                <RangeRule min={0} message={'Thứ tự phải đúng định dạng'} />
                            </SimpleItem>
                            <SimpleItem dataField={'isActive'} editorType="dxCheckBox">
                                <Label text={'Kích hoạt'} />
                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>

                    <ButtonItem colSpan={3} horizontalAlignment="center"
                        buttonOptions={saveButtonOptions}
                    />
                </Form>
            </form>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        accessToken: state.auth.data.token,
        currentLanguage: state.setting.currentLanguage,
        languages: state.setting.languages,
        currentWebsite: state.website.data.currentWebsite,
        websiteLanguages: state.website.data.languages
    };
};

PartnerDetailContainer.propTypes = {
    accessToken: PropTypes.string,
    languages: PropTypes.array,
    currentLanguage: PropTypes.string,
    websiteId: PropTypes.string,
    websiteLanguages: PropTypes.array,
    currentWebsite: PropTypes.string
};

export default connect(mapStateToProps, null)(PartnerDetailContainer);
